import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Badge, Form, Spinner } from 'react-bootstrap';
import { loadReminderPreferences } from '@renenet/shared/src/actions/settings';
import { initCurrencyInfo, saveAggregationCurrency } from '@renenet/shared/src/actions/currencies';
import Tier from '@renenet/shared/src/constants/tiers';
import PremiumGate from '../PremiumGate';
import ReminderPreferencesForm from './ReminderPreferencesForm';

// ISO 4217 fiat currency codes — kept in sync with backend tier_utils.py FIAT_CODES
const FIAT_CODES = new Set([
  'AED','AFN','ALL','AMD','ANG','AOA','ARS','AUD','AWG','AZN',
  'BAM','BBD','BDT','BGN','BHD','BIF','BMD','BND','BOB','BOV',
  'BRL','BSD','BTN','BWP','BYN','BZD','CAD','CDF','CHE','CHF',
  'CHW','CLF','CLP','CNY','COP','COU','CRC','CUC','CUP','CVE',
  'CZK','DJF','DKK','DOP','DZD','EGP','ERN','ETB','EUR','FJD',
  'FKP','GBP','GEL','GHS','GIP','GMD','GNF','GTQ','GYD','HKD',
  'HNL','HRK','HTG','HUF','IDR','ILS','INR','IQD','IRR','ISK',
  'JMD','JOD','JPY','KES','KGS','KHR','KMF','KPW','KRW','KWD',
  'KYD','KZT','LAK','LBP','LKR','LRD','LSL','LYD','MAD','MDL',
  'MGA','MKD','MMK','MNT','MOP','MRU','MUR','MVR','MWK','MXN',
  'MXV','MYR','MZN','NAD','NGN','NIO','NOK','NPR','NZD','OMR',
  'PAB','PEN','PGK','PHP','PKR','PLN','PYG','QAR','RON','RSD',
  'RUB','RWF','SAR','SBD','SCR','SDG','SEK','SGD','SHP','SLL',
  'SOS','SRD','SSP','STN','SVC','SYP','SZL','THB','TJS','TMT',
  'TND','TOP','TRY','TTD','TWD','TZS','UAH','UGX','USD','USN',
  'UYI','UYU','UYW','UZS','VES','VND','VUV','WST','XAF','XAG',
  'XAU','XBA','XBB','XBC','XBD','XCD','XDR','XOF','XPD','XPF',
  'XPT','XSU','XTS','XUA','XXX','YER','ZAR','ZMW','ZWL'
]);

function mapStateToProps(state) {
  return {
    settingsInfo: state.settingsInfo,
    currencyInfo: state.currencyInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadReminderPreferences: () => dispatch(loadReminderPreferences()),
    initCurrencyInfo: () => dispatch(initCurrencyInfo()),
    saveAggregationCurrency: (currency) => dispatch(saveAggregationCurrency(currency)),
  };
}

class PreferencesSection extends Component {
  componentDidMount() {
    this.props.loadReminderPreferences();
    this.props.initCurrencyInfo();
  }

  render() {
    const { userInfo, settingsInfo, currencyInfo } = this.props;
    const isPremium = userInfo && userInfo.tier === Tier.PREMIUM;
    const isFree = userInfo && userInfo.tier === Tier.FREE;
    const { loaded, reminderPreferences } = settingsInfo;
    const { aggregationCurrency, currencyRates } = currencyInfo;

    const availableCurrencies = Object.keys(currencyRates)
      .filter(code => !isFree || FIAT_CODES.has(code))
      .sort();

    return (
      <div>
        <h4 className="mb-1">Preferences</h4>
        <p className="text-muted mb-4">Customize how moneyplant works for you.</p>

        <div className="mb-4">
          <p className="settings-field-label mb-1">Plan</p>
          {isPremium
            ? <Badge bg="primary">Premium Plan</Badge>
            : <Badge bg="warning" text="dark">Free Plan</Badge>
          }
        </div>

        <div className="mb-4">
          <Form.Label className="settings-field-label">Display Currency</Form.Label>
          <Form.Select
            style={{ width: '200px' }}
            value={aggregationCurrency}
            onChange={e => this.props.saveAggregationCurrency(e.target.value)}
            disabled={availableCurrencies.length === 0}
          >
            {availableCurrencies.length === 0 && (
              <option value={aggregationCurrency}>{aggregationCurrency}</option>
            )}
            {availableCurrencies.map(code => (
              <option key={code} value={code}>{code}</option>
            ))}
          </Form.Select>
          <Form.Text className="text-muted">Changes apply immediately across all dashboards.</Form.Text>
        </div>

        <div>
          <p className="settings-field-label mb-2">Reminder Emails</p>
          {!isPremium && (
            <PremiumGate message="Upgrade to Premium to set up reminder emails." />
          )}
          {isPremium && !loaded && <Spinner animation="border" size="sm" />}
          {isPremium && loaded && (
            <ReminderPreferencesForm reminderPreferences={reminderPreferences} />
          )}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreferencesSection);
